<template>
    <SpinnerItem v-show="ignoreEnd" />
</template>

<script>
import SpinnerItem from './SpinnerItem.vue';

export default {
    name: 'EndlessScroll',
    props: { ignoreEnd: Boolean, onEndIsNear: Function },
    components: { SpinnerItem },

    mounted() {
        window.onscroll = this.onScroll;
    },
    beforeDestroy() {
        window.onscroll = null;
    },
    methods: {
        onScroll() {
            if (!this.ignoreEnd) {
                const closeToBottomOfWindow = document.documentElement.scrollTop + window.innerHeight + 256 >= document.documentElement.scrollHeight;
                if (closeToBottomOfWindow) {
                    this.onEndIsNear();
                }
            }
        },
    },
};
</script>

<style lang="sass" scoped></style>
